<div ngbDropdown #dropdown="ngbDropdown" [placement]="placement" (openChange)="isCollapsed = !isCollapsed">
  <div class="overlay d-md-none" [class.show]="!isCollapsed"></div>
  <div class="input-group input-type-effects-group">
    <div class="input-group-prepend">
      <button
        type="button"
        ngbDropdownToggle
        [disabled]="readOnly"
        [attr.id]="id"
        [attr.aria-label]="
          !!value
            ? ('common.change_date_action' | cxTranslate: { selectedDate: getScreenReadableDate(value) })
            : ('common.select_date_action' | cxTranslate)
        "
      >
        <i nz-icon nzType="calendar" nzTheme="outline"></i>
      </button>
    </div>
    <input
      type="text"
      [ngModel]="valueFormatted"
      (ngModelChange)="onInputChange($event)"
      [readOnly]="readOnly"
      [id]="inputId"
      [placeholder]="'common.select_date_placeholder' | cxTranslate"
      [readonly]="true"
      class="form-control"
      [ngClass]="{ 'input-focus': dropdown.isOpen() }"
      (click)="dropdown.toggle()"
    />
  </div>

  <div ngbDropdownMenu>
    <!-- It is very expensive to render this calendar input, so we should do so only after opening -->
    <ng-container *ngIf="dropdown.isOpen()">
      <py-date-picker-calendar-input
        [ngModel]="value && [value]"
        [disabledDates]="disabledDates"
        [disabledDays]="disabledDays"
        [min]="min"
        [max]="max"
        (ngModelChange)="onDateSelection($event); dropdown.close()"
      ></py-date-picker-calendar-input>

      <button *ngIf="showClearButton" class="border-0 p-0 link clear" (click)="clearDate(); dropdown.close()">
        <i nz-icon nzType="undo"></i>{{ 'common.reset_action' | cxTranslate }}
      </button>
    </ng-container>
  </div>
</div>
